import { styled } from '@mui/material';

export const StyledLeftImageHoliday = styled('div')(({ theme }) => ({
  background: `url(../assets/images/holiday-illustration-left.jpg) center center/cover`,
  width: '25%',
  height: '100vh',
  [theme.breakpoints.down('md')]: {
    position: 'absolute',
    zIndex: -1,
    width: '50%',
    left: 0,
  },
}));

export const StyledRightImageHoliday = styled('div')(({ theme }) => ({
  background: `url(../assets/images/holiday-illustration-right.jpg) center center/cover`,
  width: '25%',
  height: '100vh',
  [theme.breakpoints.down('md')]: {
    position: 'absolute',
    zIndex: -1,
    width: '50%',
    right: 0,
  },
}));

export const StyledHolidayImage = styled('div')<{ image?: string }>(({ image }) => ({
  background: `linear-gradient(45deg,
          rgba(0, 0, 0, 0.56),
          rgba(0, 0, 0, 0)),
          url(${image ?? '/assets/background/auth-bg.png'}) center/cover `,
  backgroundRepeat: 'no-repeat',
  width: '100%',
  height: 70,
  borderRadius: '10px',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 20,
  backgroundPosition: 'center',
}));

export const StyledHolidayPopup = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  margin: '2vh',
}));

export const ResponsiveStack = styled('div')(({ theme }) => ({
  width: '100%',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));
